<template>
  <div class="driver-add-item">
    <!-- Add New Customers -->
    <common-center-dialog
      :title="headerTitle"
      class="edit-Info-container ui-v2-form"
      :visible="addNewCustomersDialogVisible"
      width="800px"
      :loading="btnLoading"
      :disabled="basicInfoFlag && fromType === 'add'"
      :showHeaderLine="true"
      :isShowModal="isShowModal"
      :showFooterLine="true"
      calcelType='default'
      :appendToBody="false"
      @submit="handleSave"
      @close="addNewCustomersClose"
    >
      <div class="add-content">
        <div class="form-container">
          <el-form
            :model="form"
            ref="addBasicItemref"
            class="dialog-form-container"
          >
            <div class="basic-info common-container">
              <div class="common-container-content">
                <div class="title-h3">{{headerTitle === 'Add New Location' ? 'Basic Info' : 'Customer Info'}}</div>
                <div v-if="tabFlag !== 'Location'">
                  <el-row :gutter="24">
                    <el-col :span="6">
                      <el-form-item
                        :rules="[
                          {
                            required: true,
                            message: 'Customer Type is required',
                            trigger: 'change',
                          },
                        ]"
                        prop="customerType"
                      >
                        <common-input-select
                          :seletData="customerTypeOptions"
                          v-model="form.customerType"
                          label="Customer Type"
                          maxlength="100"
                        >
                        </common-input-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item
                        :rules="[
                          {
                            required: true,
                            message: customerName + ' is required',
                            trigger: 'blur',
                          },
                        ]"
                        prop="companyName"
                      >
                        <commonInput
                          v-model="form.companyName"
                          :label="customerName"
                          maxlength="100"
                        ></commonInput>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <common-multiple-select-checkbox
                          v-model="form.commodityType"
                          :order="1"
                          label="Commodity Type"
                          placeholder=""
                          :options="commodityTypeData"
                          @change="commodityTypeChange"
                        ></common-multiple-select-checkbox>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24">
                    <el-col :span="12">
                      <el-form-item>
                        <commonInput
                          v-model="form.streetAddress"
                          label="Street"
                          maxlength="100"
                        ></commonInput>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <common-input
                          v-model="form.city"
                          label="City"
                          maxlength="100"
                        ></common-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <common-input-select
                          :seletData="countryOptions"
                          v-model="form.country"
                          label="Country"
                        >
                      </common-input-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24">
                    <el-col :span="6">
                      <el-form-item>
                        <common-input-select
                          :seletData="stateOptions"
                          v-model="form.regisProvince"
                          label="State"
                          @focus="handleStateFocus"
                        >
                        </common-input-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item prop="zipCode" :rules="formRules.postCode.notRequired">
                        <commonInput
                          v-model="form.zipCode"
                          label="Zip Code"
                          maxlength="6"
                          @input="val => upperCase('zipCode')"
                        ></commonInput>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </div>
                <div v-else>
                  <el-row :gutter="24">
                    <el-col :span="6">
                      <el-form-item
                        :rules="[
                          {
                            required: true,
                            message: customerName + ' is required',
                            trigger: 'blur',
                          },
                        ]"
                        prop="companyName"
                      >
                        <commonInput
                          v-model="form.companyName"
                          :label="customerName"
                          maxlength="100"
                        ></commonInput>
                      </el-form-item>
                    </el-col>
                    <el-col :span="10">
                      <el-form-item
                        :rules="[
                          {
                            required: true,
                            message: 'Search Location is required',
                            trigger: 'change',
                          },
                        ]"
                        prop="locationName"
                      >
                        <City
                          @getLoaction="getLoaction"
                          labelKey="contacts"
                          v-model="form.locationName"
                          @resetCityName="resetCityName"
                        ></City>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item>
                        <commonInput
                          v-model="form.streetAddress"
                          label="Street Address"
                          maxlength="50"
                        ></commonInput>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24">
                    <el-col :span="6">
                      <el-form-item>
                        <common-input
                          :disabled="true"
                          v-model="form.city"
                          label="City"
                          maxlength="100"
                        ></common-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <common-input-select
                          :disabled="true"
                          :seletData="selfStateOptions"
                          v-model="form.regisProvince"
                          label="State"
                        >
                        </common-input-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <common-input-select
                          :disabled="true"
                          :seletData="countryOptions"
                          v-model="form.regisState"
                          label="Country"
                        >
                        </common-input-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <commonInput
                          :disabled="true"
                          v-model="form.zipCode"
                          onkeyup="this.value = this.value.replace(/[^\0-9.]/g,'');"
                          label="Zip Code"
                          maxlength="100"
                        ></commonInput>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="24">
                    <el-col :span="24">
                      <el-form-item class="notes-container">
                        <TextareaInput
                          v-model="form.notes"
                          textareaPlaceholder="Notes"
                          labelKeys="contactKey"
                          resize="none"
                          maxlength="840"
                        ></TextareaInput>
                      </el-form-item>
                    </el-col>
                    <div class="notes-tips">
                      The note here will be automatically filled into the site
                      instruction when the load is created.
                    </div>
                  </el-row>
                </div>
              </div>
            </div>
          </el-form>
          <el-form
            :model="form2"
            ref="addContactDetailref"
            class="dialog-form-container"
          >
            <div
              class="contact-detail common-container"
              v-for="(item, index) in form2.contactNumTotalData"
              :key="item.uuid"
            >
              <div class="common-container-content">
                <div class="title-h3">
                  Contact {{ index + 1 }}
                  <span
                    :class="
                      item.mainContactPerson
                        ? 'select radioIcon'
                        : 'normal radioIcon'
                    "
                    @click="radioChange(item, index)"
                  >
                    <span style="margin-left: 20px">
                      Main Contact
                    </span>
                  </span>
                  <div
                    class="delete-container"
                    @click="deleteContact(item, index)"
                    v-if="form2.contactNumTotalData.length > 1"
                  >
                    <img src="./images/icons-16-line-delete.svg" alt="" />
                    <span class="OpenSansMedium">Delete</span>
                  </div>
                </div>
                <el-row :gutter="24">
                  <el-col :span="6">
                    <el-form-item :rules="rules.firstName" :prop="'contactNumTotalData.' + index + '.firstName'">
                      <common-input
                        v-model="item.firstName"
                        label="First Name"
                        maxlength="100"
                      ></common-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6" >
                    <el-form-item
                      :rules="rules.lastName"
                      :prop="'contactNumTotalData.' + index + '.lastName'" 
                    >
                      <common-input
                        v-model="item.lastName"
                        label="Last Name"
                        maxlength="100"
                      ></common-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :rules="[formRules.email]"
                      :prop="'contactNumTotalData.' + index + '.email'"
                    >
                      <common-input
                        v-model="item.email"
                        label="Email"
                        maxlength="100"
                      ></common-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item
                      :rules="{ validator: validatePhone, trigger: 'blur' }"
                      :prop="'contactNumTotalData.' + index + '.contactNumber'"
                    >
                      <common-input
                        label="Contact Number"
                        v-model="item.contactNumber"
                        @input="value => item.contactNumber=formatPhone(value)"
                        @change="getChangeInputIndex(index)"
                        class="input-with-select"
                      >
                      </common-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="24">
                  <el-col :span="6">
                    <el-form-item>
                      <common-input
                        label="Role"
                        v-model="item.role"
                        class="input-with-select"
                        maxlength="100"
                      >
                      </common-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div
                class="line"
                v-if="
                  form2.contactNumTotalData.length > 1 &&
                    index !== form2.contactNumTotalData.length - 1
                "
              ></div>
            </div>
          </el-form>
          <div class="footer-btn">
            <div
              class="footer-btn-left"
              :class="
                showMaxTip
                  ? 'isDisabled operator-add-btn'
                  : 'isSave operator-add-btn'
              "
              @click="addContact"
            >
              <!-- <img src="./images/add.svg" alt="" /> -->
              Add Contacts
            </div>
          </div>
          <div class="clear"></div>
        </div>
      </div>
    </common-center-dialog>
    <commonDialog
      :dialogVisible="dialogVisible"
      @confirm="confirm"
      @cancel="cancel"
      title="Do you want to leave this page without saving changes?"
      content="If you don't save it, your changes will be lost."
      typeColor="#cf1322"
      confirmContent="Yes"
    ></commonDialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { isEmpty } from "lodash";
import * as formRules from "@/utils/form-rules";
import { toThousandFilter } from "@/filters";
import AreaMixin from "@/views/assets-v2/mixins/area";
import lowerFirst from "lodash/lowerFirst";
import UUID from "@/utils/uuid";
import { getContactServerInstance } from "@/data-services/contact-service";
import { formatPhone } from "@/tools/basic-methods";
import City from "@/views/dispatchs/dispatch/form/_form-add-document/city.vue";
import TextareaInput from "@/views/dispatchs/dispatch/form/_form-add-document/textarea-el-input.vue";
import appendToDom from '@/components-v3/mixins/append-to-dom';
import { countries, states } from './constants'

export default {
  components: { City, TextareaInput },
  mixins: [AreaMixin, appendToDom(document.getElementById('root'))],
  props: {
    tabFlag: {
      type: String,
      default: () => "",
    },
    headerTitle: {
      type: String,
      default: () => "",
    },
    fromType: {
      type: String,
      default: () => "",
    },
    fromTypeLoadAddCustomerName: {
      type: String,
      default: () => "",
    },
    loadCustomerName: {
      type: String,
      default: () => "",
    },
    loadBusinessName: {
      type: String,
      default: () => "",
    },
    specialTag: {
      type: String,
      default: () => "",
    },
    isShowModal: {
      type: Boolean,
      default: true,
    },
  },
  data(vm) {
    var validatePhone = (rule, value, callback) => {
      if (
        value &&

        // eslint-disable-next-line
        !/^\d{3}-\d{3}-\d{4}$/.test(value)
      ) {
        callback(new Error("Please enter a valid contact number"));
        return;
      }
      const contactNumber = formatPhone(value);
      console.log(contactNumber);
      if (contactNumber === "") {
        // if (vm.identity === 'driver') {
        //   callback(new Error('Please enter a valid phone'))
        // } else {
        callback();
        // }
      } else {
        if (!vm.formSubmitCallBack) {
          const checkItem = vm.form2.contactNumTotalData[vm.actionIndex];
          checkItem.contactNumber = contactNumber;
        }
        callback();
      }
    };
    return {
      rules: {
          firstName: [
            { required: true, message: 'First Name is required', trigger: 'change', }
          ],
          lastName: [
            { required: true, message: 'Last Name is required', trigger: 'change', }
          ],
      }, 
      form: {
        regisState: "",
        regisProvince: "",
        insuranceRegisState: "United States",
        insuranceRegisProvince: "",
        restrictions: [],
        endorsement: [],
        customerType: "",
        companyName: "",
        country: "",
      },
      validatePhone,
      customerName: "Company Name",
      form2: {
        contactNumTotalData: [
          {
            mainContactPerson: true,
            uuid: UUID.uuid(16, 32),
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            role: "",
          },
        ],
      },
      saveDisabled: true,
      showAddUserPopup: false,
      showIsSavePopup: false,
      selfStateOptions: [...states.USA],
      customerTypeOptions: [
        {
          value: "Broker",
          label: "Broker",
        },
        {
          value: "Shipper",
          label: "Shipper",
        },
      ],
      showMaxTip: false,
      basicInfoFlag: true,
      contactFlag: true,
      originForm: {},
      formRules,
      connectToELD: false,
      dialogVisible: false,
      eldDriverSeletData: [],
      terminalSeletDataDisabled: true,
      btnLoading: false,
      connectToELDDisabled: true,
      formSubmitCallBack: false,
      addNewCustomersDialogVisible: true,
      restrictions: [],
      actionIndex: 0,
      endorsement: [],
      commodityTypeData: [
        {
          label: "Dry",
          value: "Dry",
        },
        {
          label: "Freight All Kinds",
          value: "Freight All Kinds",
        },
        {
          label: "Hazardous",
          value: "Hazardous",
        },
        {
          label: "High Value",
          value: "High Value",
        },
        {
          label: "Liquid",
          value: "Liquid",
        },
        {
          label: "Livestock",
          value: "Livestock",
        },
        {
          label: "Miscellaneous",
          value: "Miscellaneous",
        },
        {
          label: "Temperature Controlled",
          value: "Temperature Controlled",
        },
      ],
      //搜索
      searchDataList: [
        {
          label: "aaaab",
          value: "123",
        },
        {
          label: "cc",
          value: "222",
        },
      ],
      licenseTypeSeletData: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
      ],
      basicInfo: {},
      loadaInfo: {},
      //terminal下拉数据
      terminalSeletData: [
        {
          label: "aaa",
          value: "aaa",
        },
        {
          label: "bbb",
          value: "bbb",
        },
      ],
      baseCardCopy: {
        vehicleNo: "",
        vehicleVin: "",
        status: "",
        fuelType: "",
        trailerType: "",
        axles: "",
        vehicleModel: "",
        vehicleMake: "",
        vehicleYear: "",
        grossVehicleWeight: "",
        incluededInIfta: "",
        // linkedWithEld: "",
      },
      countryOptions: [countries.CANADA, countries.USA],
      canadaStateOptions: [...states.CANADA],
    };
  },
  computed: {
    ...mapGetters("driver/all", ["terminalListData"]),
    stateOptions() {
      if (this.form.country === '' || this.form.country === null) {
        return [];
      }
      if (this.form.country === countries.CANADA) {
        return this.canadaStateOptions;
      }
      return this.selfStateOptions;
    },
  },
  watch: {
    // 监听baseCard 改变 connectToELDDisabled
    form: {
      handler(obj) {
        if (this.tabFlag === "Location") {
          if (obj.companyName) {
            return (this.basicInfoFlag = false);
          } else {
            return (this.basicInfoFlag = true);
          }
        } else {
          if (obj.companyName && obj.customerType) {
            return (this.basicInfoFlag = false);
          } else {
            return (this.basicInfoFlag = true);
          }
        }
      },
      immediate: true,
      deep: true,
    },
    form2: {
      // handler(data) {
      //   let firstNameFlag = data.contactNumTotalData.every((item) => {
      //     return item.firstName;
      //   });
      //   let lastNameFlag = data.contactNumTotalData.every((item) => {
      //     return item.lastName;
      //   });
      //   if (firstNameFlag && lastNameFlag) {
      //     return (this.contactFlag = false);
      //   } else {
      //     return (this.contactFlag = true);
      //   }
      // },
      // immediate: true,
      // deep: true,
    },
    'form.country': function(data) {
      if (data === countries.CANADA) {
        if (!states.CANADA.includes(this.form.regisProvince)) {
          this.form.regisProvince = null;
        }
      } else if (data === countries.USA) {
        if (!states.USA.includes(this.form.regisProvince)) {
          this.form.regisProvince = null;
        }
      }
    }
  },
  methods: {
    ...mapActions("contacts/all", ["getAddressSearch", "getAddressDetail"]),
    toThousandFilter,
    editItem() {
      this.showAddUserPopup = true;
    },
    formatPhone,
    getChangeInputIndex(index) {
      this.actionIndex = index;
    },
    isSavehandleClose() {
      this.showIsSavePopup = false;
    },
    resetCityName(data) {
      this.form.locationName = data.value;
    },
    lowerFirst,
    autocompleteHandleSelect(item) {
      this.getAddressDetail({
        context: item.context,
        id: item.id,
      }).then((res) => {
        let addressS = res.info.location.address;
        this.$set(this.form, "city", addressS.city);
        console.log(addressS);
      });
    },
    getLoaction(data) {
      console.log("getLoaction", data);
      this.loadaInfo = data.cityData;
      let houseNumber = data.cityData.souch.houseNumber ? data.cityData.souch.houseNumber + ' ' : null;
      let street = houseNumber ? houseNumber + ' ' + data.cityData.street : data.cityData.street;
      this.$set(
        this.form,
        "streetAddress",
        street
      );
      this.$set(this.form, "city", data.cityData.city);
      this.$set(this.form, "regisProvince", data.cityData.state);
      this.$set(this.form, "regisState", data.cityData.country);
      this.$set(this.form, "zipCode", data.cityData.postalCode);
      this.$set(
        this.form,
        "facilityId",
        data.cityData.souch.facilityId && data.cityData.souch.facilityId != -1
          ? data.cityData.souch.facilityId / 1
          : -1
      );
    },
    querySearch(queryString, cb) {
      if (!queryString) return;
      this.getAddressSearch({
        value: queryString,
        // searchValue: this.searchValue,
        isShowHistoricalData: true,
      }).then((res) => {
        // let currentValue =  this.CurrentIndex === 0 ? this.PickAddress : this.deliveryAddress;
        // if (queryString) return null;
        console.log(res);
        // this.searchValue = "";
        // 有历史记录时展示清除按钮
        if (!queryString && res.length) {
          res.unshift({ showClearHistory: true, value: "" });
        }
        cb(res);
      });
    },
    commodityTypeChange() {},
    deleteContact(value, index) {
      this.form2.contactNumTotalData.splice(index, 1);
      if (this.form2.contactNumTotalData.length < 50) {
        this.showMaxTip = false;
      }
    },
    radioChange(value) {
      for (let item of this.form2.contactNumTotalData) {
        item.mainContactPerson = false;
      }
      value.mainContactPerson = true;
    },
    addContact() {
      if (this.form2.contactNumTotalData.length === 50) {
        this.$message.warning({
          message: "You can add 50 contacts in maximum.",
          duration: 5000,
        });
        this.showMaxTip = true;
        return;
      }
      this.form2.contactNumTotalData.push({
        mainContactPerson: false,
        uuid: UUID.uuid(16, 32),
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        role: "",
      });
    },
    handleSave() {
      console.log(this.form);
      const p1 = new Promise((resolve) => {
        this.$refs.addBasicItemref.validate((valid) => {
          if (valid) resolve();
        });
      });

      const p2 = new Promise((resolve) => {
        this.$refs.addContactDetailref.validate((valid) => {
          if (valid) resolve();
        });
      });
      Promise.all([p1, p2]).then(() => {
        // console.log("验证通过,提交表单");
        let contactPersonArr = [];
        let source = "";
        if (this.fromTypeLoadAddCustomerName === "load") {
          source = "load";
        } else if (this.$parent.contactHomepage) {
          source = "Contact homepage";
        } else {
          source = "Specific contact page";
        }
        let params = {
          type: this.form.customerType,
          source: source,
        };
        this.$buriedPoints(13.1, params);
        for (let item of this.form2.contactNumTotalData) {
          if (
            item.firstName ||
            item.lastName ||
            item.contactNumber ||
            item.email ||
            item.role
          ) {
            contactPersonArr.push({
              firstName: item.firstName || '',
              lastName: item.lastName || '',
              contactNumber: item.contactNumber || '',
              email: item.email || '',
              mainContactPerson: item.mainContactPerson,
              role: item.role || '',
            });
          }
        }
        this.showIsSavePopup = false;
        this.btnLoading = true;
        let saveParms = {};
        let parms = {
          city: this.form.city || '',
          companyName: this.form.companyName || '',
          notes: this.form.notes || '',
          street: this.form.streetAddress || '',
          state: this.form.regisProvince || '',
          country: this.form.regisState || '',
          commodity: this.form.commodityType || '',
          zipCode: this.form.zipCode || '',
          attribute:
            (this.form.customerType && lowerFirst(this.form.customerType)) ||
            '',
          contactPerson: contactPersonArr || '',
        };
        if (this.tabFlag === "Location") {
          let obj = {
            address: this.loadaInfo?.address || '',
            timeZone: this.loadaInfo?.Tz || '',
            lat: this.loadaInfo?.latitude || '',
            lon: this.loadaInfo?.longitude || '',
            showAddress: this.loadaInfo?.showaddress || '',
            facilityId:
              this.form.facilityId && this.form.facilityId != -1
                ? this.form.facilityId / 1
                : '',
            locationName: this.form.locationName || '',
          };
          saveParms = Object.assign(parms, obj);
        } else {
          saveParms = { ...parms, country: this.form.country || '' };
        }
        console.log(saveParms);
        if (this.fromType === "add") {
          this.handleAddSubmit(saveParms);
        }
      });
    },
    confirm() {
      this.$router.push({
        name: "contacts",
        params: {
          tabFlag: this.tabFlag,
        },
      });
    },
    cancel() {
      this.dialogVisible = false;
    },
    handleCancel() {
      this.handleCloseAddPopup();
    },
    handleCloseAddPopup() {
      if (!isEmpty(this.form) || !isEmpty(this.form2)) {
        this.dialogVisible = true;
        return;
      }
      this.$router.push({
        name: "contacts",
        params: {
          tabFlag: this.tabFlag,
        },
      });
    },
    dontSave() {
      this.showIsSavePopup = false;
      this.showAddUserPopup = false;
    },
    handleAddItem() {},
    addNewCustomersClose() {
      localStorage.removeItem('addNewCustomer')
      this.$emit("addNewCustomersClose");
    },
    handleAddSubmit(form) {
      let params = {...form, ...{notes: form.notes.replaceAll('\n', '\\n')}}
      this.addCustomerApi(params)
    },
    addCustomerApi(params) {
      let self = this;
      self.btnLoading = true;
      this.$parent.contactHomepage = false;
      getContactServerInstance()
        .addContactInfo(params)
        .then(
          (result) => {
            try {
              let data = result.data.addContactInfo;
              let addContactId = data.data;
              console.log(params,'params=')
              if (data.code == "200") {
                self.$message.success({ message: "Add Success" });
                localStorage.setItem('addSuccess', params.companyName)
                self.btnLoading = false;
                this.$emit("handleAddSubmit", addContactId);
              }
            } catch (error) {
              this.$message.error({ message: error[0].message });
            }
            self.btnLoading = false;
          },
          (error) => {
            this.$message.error({ message: error[0].message });
            self.btnLoading = false;
          }
        );
    },
    upperCase(key) {
      this.form[key] = this.form[key] ? String(this.form[key]).toUpperCase() : ''
    },
    handleStateFocus() {
      if (this.form.country === '' || this.form.country === null) {
        this.$message.error("Please choose a country first.");
        return;
      }
    },
  },
  created() {
    if (this.tabFlag === "Location") {
      this.customerName = "Business Name";
    }
    this.form.customerType = this.tabFlag;
    if (this.fromTypeLoadAddCustomerName === "load") {
      this.form.companyName = "";
      if (this.loadCustomerName && !this.$parent.noShowValueFlag) {
        this.form.companyName = this.loadCustomerName;
      }
      this.form.customerType = "";
    }
    if (this.specialTag === "loadBusinessName") {
      this.form.customerType = this.tabFlag;
    }
    this.selfStateOptions = this.selfStateOptions.map((id) => {
      return {
        label: id,
        value: id,
      };
    });
  },
  mounted() {
    if(this.$route.query.searchType === "searchLoad") {
      const isAddaddNewCustomer = localStorage.getItem('addNewCustomer')
      console.log(isAddaddNewCustomer,'isAddaddNewCustomer')
      if(isAddaddNewCustomer) return
      const isAddSuccess = localStorage.getItem('addSuccess')
      const formatSearchInfo = localStorage.getItem('searchLoadInfo') && JSON.parse(localStorage.getItem('searchLoadInfo'))
      if(!formatSearchInfo.broker.company || (isAddSuccess == formatSearchInfo.broker.company)) return
      this.form = {
        companyName: formatSearchInfo.broker.company,
        customerType: 'Broker',
      }
      try {
        this.form2.contactNumTotalData = [(
            {
              email: formatSearchInfo.broker.email,
              firstName: formatSearchInfo.broker.contact_name,
              contactNumber: formatSearchInfo.broker.phone?.number ? formatPhone(formatSearchInfo.broker.phone?.number.match(/\d+/g).join('')) : '',
            }
        )]
      } catch (error) {
        console.log(error,'error-ww');
      }
      const requestData = {
          "city": "",
          "companyName": formatSearchInfo.broker.company,
          "notes": "",
          "street": "",
          "state": "",
          "country": "",
          "commodity": "",
          "zipCode": "",
          "attribute": "broker",
          "contactPerson": [
              {
                  "firstName": formatSearchInfo.broker.contact_name,
                  "lastName": '',
                  "contactNumber": formatSearchInfo.broker.phone?.number ? formatPhone(formatSearchInfo.broker.phone?.number.match(/\d+/g).join('')) : '',
                  "email": formatSearchInfo.broker.email,
                  "mainContactPerson": true,
                  "role": ""
              }
          ]
      }
      this.addCustomerApi(requestData)
    }
  }
};
</script>
<style lang="scss" scoped>
.driver-add-item {
  display: block;
  // border-radius: 2px;
  // flex: 1;
  // height: 100%;
  // overflow: hidden;
  // background: #f0f2f5;
  /deep/ {
    .common-center-dialog-container .el-dialog .el-dialog__body {
      padding: 0px 4px 0px 24px !important;
      .el-form-item__content {
        line-height: normal;
      }
    }
    .common-center-dialog-container .el-dialog .common-center-dialog-header {
      padding: 24px !important;
    }

    .notes-container {
      .el-textarea__inner {
        padding: 4px 12px 0 !important;
        min-height: 60px !important;
        color: #000c2e !important;
        font-family: OpenSans !important;
        font-size: 14px !important;
        font-weight: 600 !important;
      }
    }
  }
  .three-columns {
    display: flex;
    .el-form-item {
      flex: 1;
      &:nth-child(2) {
        margin: 0 20px;
      }
    }
  }
  
  .clear:after {
    content: "";
    display: block;
    clear: both;
  }
  ::v-deep {
    .el-input-group__prepend {
      background: #ffffff;
    }
    .el-checkbox {
      display: inline-block;
      margin-right: 24px;
    }
    .el-checkbox__inner {
      border: 1px solid #b2b6c0;
      &:hover {
        border-color: #4066d4;
      }
    }
    .el-checkbox__input.is-disabled .el-checkbox__inner {
      background-color: #f5f6f8;
      border-color: #dadce1;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner {
      border: 1px solid transparent;
    }
    .el-form-item {
      margin-bottom: 32px;
    }
    
  }
  .footer-btn {
      padding: 29px 0px 24px 0;
      max-width: 1462px;
      .footer-btn-right {
        display: inline-block;
        float: right;
      }
      .footer-btn-left {
        display: inline-block;
        color: #4066d4;
        cursor: pointer;
        font-weight: 600;
        img {
          position: relative;
          top: 2px;
        }
      }
      .operator-add-btn {
        background-repeat: no-repeat;
        background-size: 16px;
        padding-left: 22px;
        font-weight: 600;
        font-size: 14px;
        background-position: left center;
        cursor: pointer;
        display: inline-block;
      }
      .isDisabled {
        color: #b2b6c0;
        background-image: url("../../assets/img/info/icons-16-line-add.svg");
        cursor: not-allowed;
        pointer-events: none;
      }
      .isSave {
        color: #4066d4;
        background-image: url("../../assets/img/info/icons-line-add.svg");
      }
      .cancel-btn {
        color: #4c556c;
        font-weight: 500 !important;
        font-size: 16px;
        font-weight: 500;
        margin-right: 24px;
        cursor: pointer;
      }
      .save-btn {
        padding: 8px 18px;
        span {
          font-weight: 500 !important;
          font-size: 16px;
          font-weight: 500;
        }
        background: #4066d4;
        &:hover {
          background: #4066d4;
        }
      }
      .save-btn.is-disabled {
        span {
          font-weight: 500 !important;
          font-size: 16px;
          font-weight: 500;
        }
        background: #dadce1;
        border-color: #dadce1;
      }
  }
  .notes-tips {
    font-weight: 500;
    font-size: 12px;
    font-weight: 500;
    color: #b2b6c0;
    padding-left: 12px;
    position: relative;
    top: 4px;
    display: flex;
  }
  /deep/ {
    .el-textarea__inner::placeholder {
      font-weight: 500;
      font-size: 12px;
      font-weight: 500;
      letter-spacing: normal;
      color: #7f8596;
    }
  }
}
.add-content {
    max-height: 576px;
    overflow-y: auto;
    overflow-x: hidden;
    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-thumb {
      width: 8px;
    }
    .form-container {
      width: 752px;
    }
    .dialog-form-container {
      .common-container {
        background: #ffffff;
        padding: 24px 0px 0 0;
        // border-bottom: 1px solid #dadce1;
        .common-container-content {
          max-width: 1440px;
        }
      }
      .basic-info {
        padding: 24px 0;
        border-bottom: 1px solid #dadce1;
      }
      .line {
        width: 100%;
        height: 1px;
        background: #dadce1;
        margin-top: 24px;
      }
    }
    .title-h3 {
      font-weight: bold;
      font-size: 14px;
      font-weight: bold;
      color: #000000;
      margin-bottom: 24px;
      ::v-deep {
        .el-radio__label {
          font-weight: bold;
          font-size: 14px;
          font-weight: bold;
          color: #000000;
        }
      }
      .delete-container {
        float: right;
        cursor: pointer;
        img {
          vertical-align: text-top;
          margin-right: 4px;
        }
        span {
          font-size: 14px;
          color: #cf1322;
        }
      }
      .radioIcon {
        // display: inline-block;
        // width: 16px;
        // height: 16px;
        cursor: pointer;
        vertical-align: middle;
        margin-left: 24px;
        span {
          font-size: 12px;
          font-family: OpenSans-Semibold !important;
          font-weight: bold !important;
          position: relative;
          top: -1px;
        }
      }
      .radioIcon.normal {
        background: url("./images/radio-normal.svg") no-repeat 0px 1px;
      }
      .radioIcon.select {
        background: url("./images/radio-select.svg") no-repeat 0px 1px;
        color: #4066d4;
      }
    }
    .title-h4 {
      font-weight: 500;
      font-size: 14px;
      font-weight: 500;
      color: #000000;
      margin-bottom: 24px;
    }
    .el-row:last-child {
      .el-form-item {
        margin-bottom: 0px !important;
      }
    }
  }
</style>
